export default __webpack_public_path__ + "static/banner-how-to-make-debt-work-for-you-796599fd9f88f791ecb9d0c7865008b9.jpg";